import { useBusinessInfo } from '~/lib/Queries';

const PackageRedemptionClientText = ({ client, className }) => {
    const { data } = useBusinessInfo();

    const distinctByName = data?.clientDistinct === 'name';

    // Each interpolated value gets its own <span> so React swaps elements
    //  rather than editing loose text nodes. iOS data detectors rewrap
    //  email/phone-like text in an <a> of their own, which re-parents a bare
    //  text node out from under React and makes removeChild() throw when the
    //  surrounding panel unmounts.
    const emailSuffix = client?.email ? ` (${client.email})` : '';

    return (
        <div className={className}>
            {distinctByName && (
                <>
                    This will be automatically redeemed when this client books
                    as <span>{client?.name}</span> <span>{emailSuffix}</span>.
                </>
            )}
            {!distinctByName && (
                <>
                    This will be automatically redeemed when this client books
                    with their email address
                    <span>{emailSuffix}</span>.
                </>
            )}
        </div>
    );
};

export default PackageRedemptionClientText;
